import { ReactNode } from 'react';
import AddIcon from '@mui/icons-material/Add';
import Divider from '@mui/material/Divider';
import Fab from '@mui/material/Fab';
import Typography from '@mui/material/Typography';

import styles from './page-header.module.scss';

type Props = {
  title: string;
  description?: string;
  descriptionComponent?: ReactNode;
  addBtnVisible?: boolean;
  addBtnDisabled?: boolean;
  onAdd?: React.ReactEventHandler<object>;
  navigationComponent?: ReactNode;
  filterComponent?: ReactNode;
  hideDivider?: boolean;
};

const PageHeader = ({
  title,
  description,
  descriptionComponent,
  addBtnVisible = false,
  addBtnDisabled = false,
  onAdd,
  navigationComponent,
  filterComponent,
  hideDivider,
}: Readonly<Props>): React.JSX.Element => {
  return (
    <div className={styles.pageHeaderContainer}>
      <div className={styles.pageHeaderAndTabContainer}>
        <div>
          <Typography variant="h3">{title}</Typography>
          <Typography className={styles.descriptionContainer} variant="subtitle1">
            {description}
          </Typography>
          <div className={styles.descriptionContainer}>{descriptionComponent}</div>
        </div>
        {navigationComponent}
      </div>
      {filterComponent}
      {hideDivider !== true && <Divider className={styles.pageHeaderDivider} />}
      {addBtnVisible && (
        <Fab data-testid="pageHeaderAddButton" aria-label="add" className={styles.addButton} onClick={onAdd} disabled={addBtnDisabled}>
          <AddIcon />
        </Fab>
      )}
    </div>
  );
};

export default PageHeader;
